import './RulesManagement.scss';
import { v4 as uuid } from 'uuid';
import { RulesConstants, RulesTracks } from '../../../rules/RulesConstants';
import { debounce } from 'data/function';
import { ToastType } from 'modules/application/misc/ToastService';
export class RuleContainerController {
    static $inject = ['$scope', 'DeskConfigurationService', 'LoadingService', 'AlertService', 'SegmentService', 'RulesService', '$translate', 'LoadValues', 'PermissionsService'];
    constructor($scope, DeskConfigurationService, LoadingService, AlertService, SegmentService, RulesService, $translate, LoadValues, PermissionsService) {
        'ngInject';
        this.$scope = $scope;
        this.DeskConfigurationService = DeskConfigurationService;
        this.LoadingService = LoadingService;
        this.AlertService = AlertService;
        this.SegmentService = SegmentService;
        this.RulesService = RulesService;
        this.$translate = $translate;
        this.LoadValues = LoadValues;
        this.PermissionsService = PermissionsService;
        this.inputTextSearchRules = '';
        this.isManagerView = true;
        this.isQueueManagementView = true;
        this.currentState = RulesConstants.STATES.VIEWING;
        this.isViewing = RulesConstants.STATES.VIEWING;
        this.isAdding = RulesConstants.STATES.ADDING;
        this.isEdit = RulesConstants.STATES.EDITING;
        this.searchRule = async (event) => {
            this.inputTextSearchRules = event.detail.value;
            this.setIsLoading(true);
            if (this.inputTextSearchRules) {
                this.filterRules();
            }
            else {
                this.filteredRules = this.rules.slice();
                this.filteredRulesCount = this.rulesCount;
                this.checkLoadMoreStatus();
            }
            this.setIsLoading(false);
            this.SegmentService.createBotTrack(RulesTracks.RULES_SEARCHED, this.application, this.trackPayload);
        };
    }
    async $onInit() {
        this.setIsLoading(false);
        this.itemsPerPage = 10;
        this.perPageAux = 0;
        this.rules = [];
        this.filteredRules = [];
        this.rulesCount = 0;
        this.filteredRulesCount = 0;
        this.debouncedSearch = debounce(this.searchRule, 500);
        this.properties = await this.LoadValues.loadProperties();
        this.relations = await this.LoadValues.loadRelations();
        this.operators = await this.LoadValues.loadOperators();
        this.teams = await this.RulesService.fetchTeams(this.application);
        this.canEditRule = await this.PermissionsService.hasPermissions(RulesConstants.WRITE, RulesConstants.DESK);
        this.canSeeRule = await this.PermissionsService.hasPermissions(RulesConstants.READ, RulesConstants.DESK);
        this.isEditing = false;
        if (this.queue.id != '') {
            await this.fetchRules();
        }
        this.trackPayload = { source: RulesTracks.SOURCE.PORTAL };
        this.SegmentService.createBotTrack(RulesTracks.PAGE_OPENED, this.application, this.trackPayload);
    }
    setCurrentState(state) {
        this.currentState = state;
    }
    setIsLoading(isLoading) {
        this.isLoading = isLoading;
    }
    cancelAction(index) {
        if (this.currentState === RulesConstants.STATES.ADDING) {
            this.filteredRules.splice(index, 1);
        }
        else if (this.currentState === RulesConstants.STATES.EDITING) {
            this.changeStatusItem(index);
        }
        this.setCurrentState(RulesConstants.STATES.VIEWING);
    }
    async closeOpenedRule(index) {
        if (this.filteredRules[index].opened) {
            this.changeStatusItem(index);
        }
        this.setCurrentState(RulesConstants.STATES.VIEWING);
        await this.fetchRules();
        if (this.inputTextSearchRules) {
            this.filterRules();
        }
        this.teams = await this.RulesService.fetchTeams(this.application);
        this.onChange({ $length: this.teams.length || 0 });
    }
    async editRule(index) {
        this.setCurrentState(RulesConstants.STATES.EDITING);
        await this.changeStatusItem(index);
    }
    async changeStatusItem(index) {
        for (const [i, rule] of this.filteredRules.entries()) {
            rule.opened = i === index ? !rule.opened : false;
        }
    }
    async toggleRule(rule) {
        await this.RulesService.set(this.application, rule);
    }
    async filterRules() {
        this.setIsLoading(true);
        this.filteredRules = [];
        this.filteredRulesCount = 0;
        try {
            const { rules, total } = await this.RulesService.filterRulesByQueue(this.queue.name, this.inputTextSearchRules, this.filteredRules.length, this.itemsPerPage);
            this.filteredRules.push(...rules);
            this.filteredRulesCount = total;
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.setIsLoading(false);
            this.checkLoadMoreStatus();
        }
    }
    checkLoadMoreStatus() {
        if (this.isFilterMode()) {
            this.canLoadMore = this.filteredRules.length < this.filteredRulesCount;
        }
        else {
            this.canLoadMore = this.rules.length < this.rulesCount;
        }
    }
    isFilterMode() {
        if (this.inputTextSearchRules == undefined || this.inputTextSearchRules === '') {
            return false;
        }
        return true;
    }
    async clearSearch() {
        this.inputTextSearchRules = '';
        this.currentState = RulesConstants.STATES.VIEWING;
        this.filteredRules = this.rules.slice();
        this.filteredRulesCount = this.rulesCount;
        this.checkLoadMoreStatus();
        this.SegmentService.createBotTrack(RulesTracks.CLEAR_SEARCH, this.application, this.trackPayload);
    }
    async changeStatus(value, index) {
        if (this.canEditRule) {
            const rule = {
                ...this.filteredRules[index],
                isActive: value,
            };
            this.saveRule(rule, index);
        }
        else {
            this.RulesService.showToast('builder-attendance-rules.errors.cannotEdit', ToastType.Danger);
        }
    }
    async createRule() {
        if (this.currentState === RulesConstants.STATES.ADDING || this.currentState === RulesConstants.STATES.EDITING) {
            return;
        }
        if (!this.queue.id) {
            const toastMessageReference = 'queue-management.errors.newNameBeforeEditRules';
            const toastType = ToastType.Danger;
            await this.RulesService.showToast(toastMessageReference, toastType);
            return;
        }
        this.setCurrentState(RulesConstants.STATES.ADDING);
        const title = await this.$translate('attendance-rules.rules.ruleName');
        const newRule = {
            id: uuid(),
            title: `${title}`,
            conditions: [
                {
                    property: 'Message',
                    relation: 'Contains',
                    values: [],
                },
            ],
            team: this.queue.name || RulesConstants.DEFAULT_TEAM_NAME,
            queueId: this.queue?.uniqueId,
            isActive: true,
            opened: true,
            operator: RulesConstants.DEFAULT_OPERATOR,
            repeatConditionsBody: false,
            valuesEmpty: true,
        };
        this.filteredRules.unshift(newRule);
        const input = document.getElementById(`rule-title-${this.filteredRules.length - 1}`);
        if (input) {
            input.focus();
            this.changeStatusItem(this.filteredRules.length - 1);
        }
        this.SegmentService.createBotTrack(RulesTracks.RULE_ADDED, this.application, this.trackPayload);
    }
    clearRuleList(data) {
        if (data.id) {
            return;
        }
        this.filteredRules.pop();
    }
    async saveRule(data, index) {
        let rule;
        let toastMessageReference;
        let toastType;
        this.LoadingService.startLoading();
        rule = {
            id: uuid(),
            team: RulesConstants.DEFAULT_TEAM_NAME,
            ...data,
        };
        toastMessageReference =
            this.currentState === RulesConstants.STATES.ADDING
                ? 'attendance-rules.rules.confirmAddRule'
                : 'attendance-rules.rules.confirmEdit';
        try {
            await this.RulesService.set(this.application, rule);
            this.SegmentService.createBotTrack(RulesTracks.RULE_SAVED, this.application, this.trackPayload);
            toastType = ToastType.Success;
        }
        catch (ex) {
            toastMessageReference = 'utils.errorMsg.112';
            toastType = ToastType.Danger;
        }
        finally {
            this.closeOpenedRule(index);
            this.LoadingService.stopLoading();
            await this.RulesService.showToast(toastMessageReference, toastType);
            this.setIsLoading(false);
        }
    }
    async confirmDelete(rule) {
        try {
            const modalTitle = await this.$translate('modules.application.detail.attendance.rules.builder.confirmDeleteTitle');
            const modalBody = await this.$translate('modules.application.detail.attendance.rules.builder.confirmDeleteBody', { team: rule.team });
            const confirm = await this.$translate('attendance-rules.actions.exclude');
            const cancel = await this.$translate('attendance-rules.actions.abortAction');
            await this.AlertService.show({
                title: modalTitle,
                body: modalBody,
                variant: 'delete',
                icon: 'trash',
                buttons: {
                    cancel: cancel,
                    confirm: confirm,
                },
                callback: {
                    cancelButtonAction: () => { },
                    confirmButtonAction: () => this.delete(rule),
                },
            });
        }
        catch (e) {
            console.error(e);
        }
    }
    async delete(rule) {
        let toastMessageReference;
        let toastType;
        try {
            this.LoadingService.startLoading();
            await this.RulesService.delete(rule);
            await this.fetchRules();
            toastMessageReference = 'attendance-rules.rules.confirmRemoveRule';
            toastType = ToastType.Success;
            this.SegmentService.createBotTrack(RulesTracks.RULE_DELETED, this.application, this.trackPayload);
        }
        catch (e) {
            toastMessageReference = 'utils.errorMsg.113';
            toastType = ToastType.Danger;
        }
        finally {
            this.LoadingService.stopLoading();
            await this.RulesService.showToast(toastMessageReference, toastType);
        }
    }
    isAnyRuleOpen() {
        return this.filteredRules.some(r => r.opened);
    }
    async fetchRules() {
        if (this.isLoading) {
            return;
        }
        this.setIsLoading(true);
        try {
            this.inputTextSearchRules = '';
            this.rules = [];
            const { rules, total } = await this.RulesService.getRulesQueue(this.queue.name, this.perPageAux, this.itemsPerPage);
            this.rules.push(...rules);
            this.filteredRules = this.rules.slice();
            this.rulesCount = total;
            this.filteredRulesCount = this.rulesCount;
            this.checkLoadMoreStatus();
            this.setIsLoading(false);
            this.onChange({ $length: total || 0 });
        }
        catch (e) {
            console.error(e);
        }
    }
    async loadMore() {
        if (this.isFilterMode()) {
            const { rules, total } = await this.RulesService.filterRulesByQueue(this.queue.name, this.inputTextSearchRules, this.filteredRules.length, this.itemsPerPage);
            this.filteredRules.push(...rules);
            this.filteredRulesCount = total;
            this.checkLoadMoreStatus();
        }
        else {
            const { rules, total } = await this.RulesService.getRulesQueue(this.queue.name, this.rules.length, this.itemsPerPage);
            this.rules.push(...rules);
            this.rulesCount = total;
            this.filteredRulesCount = total;
            this.filteredRules = this.rules.slice();
            this.checkLoadMoreStatus();
        }
    }
}
RuleContainerController.$inject = ['$scope', 'DeskConfigurationService', 'LoadingService', 'AlertService', 'SegmentService', 'RulesService', '$translate', 'LoadValues', 'PermissionsService'];
